import React, { useState, useEffect, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const COMMON_ITEMS = {
  Fresh: [
    'Apples', 'Bananas', 'Oranges', 'Limes', 'Onions', 'Garlic', 'Potatoes',
    'Sweet potatoes', 'Carrots', 'Bell peppers', 'Tomatoes', 'Zucchini',
    'Cabbage', 'Lettuce', 'Cucumbers', 'Lemon', 'Blueberry', 'Raspberry',
    'Blackberry', 'Dragon Fruit', 'Pineapple', 'Mango', 'Broccoli', 'Celery',
    'Cauliflower', 'Eggplant', 'Spinach', 'Kale', 'Cherry Tomato', 'Yellow Squash',
    'Butternut Squash', 'Bok Choy', 'Green Onion', 'Shallot', 'Avocado', 'Pear',
    'Peach', 'Grapes', 'Strawberries', 'Kiwi', 'Papaya', 'Watermelon', 'Asparagus',
    'Brussels Sprouts', 'Snap Peas', 'Green Beans', 'Mushrooms', 'Radishes', 'Beets',
    'Turnips', 'Parsnips', 'Artichoke', 'Plum', 'Apricot', 'Fig', 'Pomegranate',
    'Coconut', 'Persimmon', 'Guava', 'Passion Fruit', 'Starfruit', 'Romaine Lettuce',
    'Arugula', 'Leek', 'Collard Greens', 'Bread Fruit'
  ],
  Refrigerated: [
    'Eggs', 'Milk', 'Almond milk', 'Butter', 'Cheese', 'Yogurt',
    'Heavy Cream', 'Sour cream', 'Half-and-Half', 'Cottage Cheese',
    'Ricotta Cheese', 'Cream Cheese', 'Feta Cheese', 'Fresh Mozzarella',
    'Pizza Dough', 'Pesto', 'Hummus', 'Guacamole', 'Tzatziki'
  ],
  Proteins: [
    'Chicken breast', 'Ground beef', 'Sausages', 'Bacon', 'Ham',
    'Canned tuna', 'Canned salmon', 'Sardines', 'Spam', 'Hot dogs', 'Steak',
    'Tuna', 'Salmon', 'Shrimp', 'Lobster', 'Crab', 'Clams', 'Scallops',
    'Ground Chicken', 'Ground Turkey', 'Chicken Thigh', 'Chicken Wing',
    'Chicken Tender', 'Cod/Saltfish', 'Snapper'
  ],
  'Dry Goods': [
    'Rice', 'Pasta', 'Couscous', 'Quinoa', 'Flour', 'Sugar', 'Brown sugar',
    'Oats', 'Bread', 'Tortillas', 'Crackers', 'Pancake mix', 'Ramen noodles',
    'Farro', 'Grits', 'Cornmeal', 'Semolina', 'Rice Noodles', 'Egg Noodles',
    'Baking Powder', 'Baking Soda', 'Yeast', 'Cornstarch', 'Cocoa Powder',
    'Powdered Sugar', 'Pudding Mix', 'Gelatin', 'Breadcrumbs', 'Panko',
    'Beans (dry)', 'Lentils (dry)', 'Raisins', 'Cranberries (dried)', 'Dates',
    'Chocolate Chips', 'Cereal', 'Bouillon Cubes'
  ],
  'Canned / Jarred': [
    'Canned beans', 'Chickpeas', 'Lentils', 'Corn', 'Green beans', 'Peas',
    'Diced tomatoes', 'Pasta sauce', 'Tomato paste', 'Soup', 'Chili',
    'Mixed Vegetables', 'Water Chestnuts', 'Bamboo Shoots', 'Sauerkraut',
    'Fruit Cocktail', 'Chicken Broth', 'Beef Broth', 'Vegetable Broth',
    'Bone Broth', 'Clam Chowder', 'Coconut Milk', 'Curry Sauce', 'Mole Sauce'
  ],
  Condiments: [
    'Olive oil', 'Soy sauce', 'Hot sauce', 'Ketchup', 'Mustard', 'Mayonnaise',
    'Honey', 'Coconut Oil', 'Vegetable Oil', 'Canola Oil', 'Vinegar', 'Balsamic Vinegar',
    'Aioli', 'Horseradish', 'Fresh Salsa', 'Chimichurri', 'Salad Dressing',
    'Teriyaki Sauce', 'Oyster Sauce', 'Sriracha', 'Syrup', 'Agave Syrup',
    'Nutella', 'Chocolate Syrup'
  ],
  Snacks: [
    'Peanut butter', 'Jelly', 'Granola bars', 'Trail mix', 'Potato Chips',
    'Cookies', 'Chocolate', 'Popcorn', 'Nuts', 'Pretzel', 'Brownies',
    'Muffins', 'Cupcakes', 'Donuts', 'Rice Krispie Treats', 'Protein Bars',
    'Fruit Snacks', 'Candy', 'Marshmallows', 'Biscotti', 'Tortilla Chips',
    'Cheese Crackers', 'Goldfish Crackers', 'Chex Mix', 'Snack Mix',
    'Wasabi Peas', 'Rice Cakes', 'Pork Rinds', 'Dried Fruit', 'Banana Chips',
    'String Cheese', 'Pudding', 'Churro'
  ],
  Beverages: [
    'Water', 'Coffee', 'Tea', 'Milk', 'Orange Juice', 'Lemonade',
    'Iced Tea', 'Soda', 'Sports Drink', 'Wine', 'Fruit Juice',
    'Ginger Ale', 'Club Soda', 'Sparkling Water', 'Cola',
    'Lemon-Lime Soda', 'Root Beer', 'Chai', 'Beer', 'Cider',
    'Champagne', 'Rosé', 'Coconut Water', 'Protein Shake'
  ]
};

const AddItemForm = ({ onAdd, editingItem, onCancelEdit }) => {
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    quantity: '',
    unit: ''
  });

  const [errors, setErrors] = useState({});
  const [isListening, setIsListening] = useState(false);
  const [showCommonItems, setShowCommonItems] = useState(false);
  const [selectedCommonCategory, setSelectedCommonCategory] = useState(null);
  const recognitionRef = useRef(null);
  const dropdownRef = useRef(null);

  const categoryOptions = [
    { value: 'Fresh', label: 'Fresh' },
    { value: 'Refrigerated', label: 'Refrigerated' },
    { value: 'Proteins', label: 'Proteins' },
    { value: 'Canned', label: 'Canned' },
    { value: 'Dry', label: 'Dry' },
    { value: 'Snack', label: 'Snack' },
    { value: 'Condiment', label: 'Condiment' },
    { value: 'Beverage', label: 'Beverage' },
    { value: 'Other', label: 'Other' }
  ];

  const unitOptions = [
    { value: 'kg', label: 'Kilograms (kg)' },
    { value: 'g', label: 'Grams (g)' },
    { value: 'lb', label: 'Pounds (lb)' },
    { value: 'oz', label: 'Ounces (oz)' },
    { value: 'L', label: 'Liters (L)' },
    { value: 'ml', label: 'Milliliters (ml)' },
    { value: 'gal', label: 'Gallons (gal)' },
    { value: 'qt', label: 'Quarts (qt)' },
    { value: 'pt', label: 'Pints (pt)' },
    { value: 'cup', label: 'Cups' },
    { value: 'tbsp', label: 'Tablespoons' },
    { value: 'tsp', label: 'Teaspoons' },
    { value: 'pcs', label: 'Pieces' },
    { value: 'cans', label: 'Cans' },
    { value: 'bottles', label: 'Bottles' },
    { value: 'bags', label: 'Bags' },
    { value: 'boxes', label: 'Boxes' }
  ];

  useEffect(() => {
    if (editingItem) {
      setFormData({
        name: editingItem?.name,
        category: editingItem?.category,
        quantity: editingItem?.quantity?.toString(),
        unit: editingItem?.unit
      });
    }
  }, [editingItem]);

  useEffect(() => {
    // Initialize Web Speech API
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      recognitionRef.current = new SpeechRecognition();
      recognitionRef.current.continuous = false;
      recognitionRef.current.interimResults = false;
      recognitionRef.current.lang = 'en-US';

      recognitionRef.current.onresult = (event) => {
        const transcript = event?.results?.[0]?.[0]?.transcript;
        handleChange('name', transcript);
        setIsListening(false);
      };

      recognitionRef.current.onerror = () => {
        setIsListening(false);
      };

      recognitionRef.current.onend = () => {
        setIsListening(false);
      };
    }

    return () => {
      if (recognitionRef?.current) {
        recognitionRef?.current?.stop();
      }
    };
  }, []);

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setShowCommonItems(false);
        setSelectedCommonCategory(null);
      }
    };

    if (showCommonItems) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCommonItems]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors?.[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.name?.trim()) {
      newErrors.name = 'Item name is required';
    }

    if (!formData?.category) {
      newErrors.category = 'Category is required';
    }

    if (!formData?.quantity || parseFloat(formData?.quantity) <= 0) {
      newErrors.quantity = 'Valid quantity is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    
    if (validateForm()) {
      const itemData = {
        ...formData,
        quantity: parseFloat(formData?.quantity),
        lastUsed: editingItem ? editingItem?.lastUsed : null
      };

      if (editingItem) {
        onAdd({ ...itemData, id: editingItem?.id });
      } else {
        onAdd(itemData);
      }

      setFormData({
        name: '',
        category: '',
        quantity: '',
        unit: ''
      });
      setErrors({});
    }
  };

  const handleCancel = () => {
    setFormData({
      name: '',
      category: '',
      quantity: '',
      unit: ''
    });
    setErrors({});
    if (onCancelEdit) {
      onCancelEdit();
    }
  };

  const handleVoiceInput = () => {
    if (!recognitionRef?.current) {
      alert('Speech recognition is not supported in your browser.');
      return;
    }

    if (isListening) {
      recognitionRef?.current?.stop();
      setIsListening(false);
    } else {
      recognitionRef?.current?.start();
      setIsListening(true);
    }
  };

  const handleCommonItemSelect = (itemName, category) => {
    // Map common item categories to inventory categories
    const categoryMap = {
      'Fresh': 'Fresh',
      'Refrigerated': 'Refrigerated',
      'Proteins': 'Proteins',
      'Dry Goods': 'Dry',
      'Canned / Jarred': 'Canned',
      'Condiments': 'Condiment',
      'Snacks': 'Snack',
      'Beverages': 'Beverage'
    };

    setFormData(prev => ({
      ...prev,
      name: itemName,
      category: categoryMap?.[category] || category
    }));
    setShowCommonItems(false);
    setSelectedCommonCategory(null);
  };

  const handleCommonItemsToggle = () => {
    setShowCommonItems(!showCommonItems);
    setSelectedCommonCategory(null);
  };

  const handleCategorySelect = (category) => {
    setSelectedCommonCategory(selectedCommonCategory === category ? null : category);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-2">
          <Icon name="Package" size={24} className="text-primary" />
          <h2 className="text-lg md:text-xl font-semibold text-foreground">
            {editingItem ? 'Edit Item' : 'Add New Item'}
          </h2>
        </div>
        {editingItem && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleCancel}
            iconName="X"
            iconPosition="left"
          >
            Cancel
          </Button>
        )}
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="relative" ref={dropdownRef}>
          <Button
            type="button"
            variant="outline"
            onClick={handleCommonItemsToggle}
            iconName="List"
            iconPosition="left"
            className="w-full mb-4"
          >
            Select from Common Items
          </Button>

          {showCommonItems && (
            <div className="absolute z-50 w-full mt-1 bg-card border border-border rounded-lg shadow-lg max-h-96 overflow-y-auto">
              {!selectedCommonCategory ? (
                <div className="p-2">
                  <div className="px-3 py-2 text-xs font-semibold text-muted-foreground uppercase tracking-wide">
                    Select Category
                  </div>
                  {Object.keys(COMMON_ITEMS)?.map((category) => (
                    <button
                      key={category}
                      type="button"
                      onClick={() => handleCategorySelect(category)}
                      className="w-full text-left px-3 py-2 hover:bg-accent rounded-md transition-colors flex items-center justify-between group"
                    >
                      <span className="text-sm font-medium text-foreground">{category}</span>
                      <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-foreground" />
                    </button>
                  ))}
                </div>
              ) : (
                <div className="p-2">
                  <button
                    type="button"
                    onClick={() => setSelectedCommonCategory(null)}
                    className="w-full text-left px-3 py-2 mb-2 hover:bg-accent rounded-md transition-colors flex items-center gap-2"
                  >
                    <Icon name="ChevronLeft" size={16} className="text-muted-foreground" />
                    <span className="text-sm font-medium text-muted-foreground">Back to Categories</span>
                  </button>
                  <div className="px-3 py-2 text-xs font-semibold text-muted-foreground uppercase tracking-wide border-t border-border">
                    {selectedCommonCategory}
                  </div>
                  {COMMON_ITEMS?.[selectedCommonCategory]?.map((item) => (
                    <button
                      key={item}
                      type="button"
                      onClick={() => handleCommonItemSelect(item, selectedCommonCategory)}
                      className="w-full text-left px-3 py-2 hover:bg-accent rounded-md transition-colors"
                    >
                      <span className="text-sm text-foreground">{item}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Item Name *
            </label>
            <div className="flex gap-2">
              <Input
                type="text"
                value={formData?.name}
                onChange={(e) => handleChange('name', e?.target?.value)}
                placeholder="e.g., Fresh Tomatoes"
                error={errors?.name}
                className="flex-1"
              />
              {recognitionRef?.current && (
                <Button
                  type="button"
                  variant={isListening ? 'default' : 'outline'}
                  size="icon"
                  onClick={handleVoiceInput}
                  iconName="Mic"
                  aria-label="Voice input"
                  className={isListening ? 'animate-pulse' : ''}
                />
              )}
            </div>
            {errors?.name && (
              <p className="text-sm text-destructive mt-1">{errors?.name}</p>
            )}
          </div>

          <Select
            label="Category"
            placeholder="Select category"
            options={categoryOptions}
            value={formData?.category}
            onChange={(value) => handleChange('category', value)}
            error={errors?.category}
            required
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Quantity"
              type="number"
              placeholder="0"
              value={formData?.quantity}
              onChange={(e) => handleChange('quantity', e?.target?.value)}
              error={errors?.quantity}
              required
              min="0"
              step="0.01"
            />

            <Select
              label="Unit"
              placeholder="Select unit (optional)"
              options={unitOptions}
              value={formData?.unit}
              onChange={(value) => handleChange('unit', value)}
              error={errors?.unit}
              searchable
            />
          </div>
        </div>

        <Button
          type="submit"
          variant="default"
          className="w-full"
          iconName={editingItem ? 'Check' : 'Plus'}
          iconPosition="left"
        >
          {editingItem ? 'Update Item' : 'Add Item'}
        </Button>
      </form>
    </div>
  );
};

export default AddItemForm;